import Vue from 'vue';
import Vuex from 'vuex';
import kanban from '@/store/modules/kanban';
import VuexORM from '../orm';
import social from './modules/social';
import candidatePage from './modules/candidatePage';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [VuexORM],
  modules: {
    social,
    candidatePage,
    kanban,
  },
  strict: process.env.NODE_ENV !== 'production',
});
